import React from "react";
import { Breadcrumb, Card, Col, Container, Figure, Row } from "react-bootstrap";
import { sponsors } from "../components/shared/constraints";

const Achievers = () => {
  return (
    <div className="inner-wrapper pb-0">
      <div className="page-title mb-md-5 mb-4">
        <div class="common-heading text-center mb-sm-3 mb-2">
          <h2>Achievers</h2>
        </div>
        <Breadcrumb>
          <Breadcrumb.Item href="#" className="text-decoration-none ">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active className="text-orange">
            Achievers
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <section className="sponser-sec  pt-0 our-team-member pb-0 ">
        <Container>
          <div class="common-heading text-center mb-4">
            <h2>
              Achievers
              <span className="text-orange d-inline-block px-2">List</span>2024
            </h2>
          </div>
          <Row className="gx-3 achiever-box">
            {sponsors.map((sponsor, index) => (
              <Col lg={3} md={4} xs={6} className="mb-md-5 mb-3" key={index}>
                <Card className="sponser-cards speaker-box-layout2 position-relative">
                  <Figure>
                    <Card.Img variant="top" src={sponsor.image} alt="Profile" />
                  </Figure>
                  <Card.Body className="text-start">
                    <Card.Title className="fw-bold fs-6">
                      {sponsor.name}
                    </Card.Title>
                    <Card.Text
                      style={{ color: "gray", fontSize: "14px" }}
                      className="mb-0"
                    >
                      {sponsor.role}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Achievers;
